export const DD_RUM_USER_COOKIE = 'DD_RUM_USER'
